import React from "react";
import styled from "styled-components";
import { injectStripe, PaymentRequestElement } from "react-stripe-elements";

class PaymentRequestForm extends React.Component {
  constructor(props) {
    super(props);
    const paymentRequest = props.stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: this.props.label || "Top Nine",
        amount: parseInt(this.props.amount || 199),
      },
    });

    paymentRequest.on("click", () => {
      if (window.gtag) {
        window.gtag("event", "checkout_progress", {
          event_label: this.state.applePay ? "applePay" : "paymentRequest",
        });
        window.gtag("event", `onclick_${this.state.applePay ? "applePay" : "paymentRequest"}`);
      }
    });

    paymentRequest.on("token", ({ complete, token, ...data }) => {
      complete("success");
      this.props.onTokenSuccess(token, this.state.applePay ? "applePay" : "paymentRequest");
    });

    paymentRequest.canMakePayment().then(result => {
      if (this.props.setCanMakePaymentWithButton) {
        if (result && result.applePay && window.gtag) {
          window.gtag("event", "can_make_payment_apple_pay");
        } else if (result && window.gtag) {
          window.gtag("event", "can_make_payment_request");
        }
        if (this.props.setCanMakePaymentWithButton) {
          this.props.setCanMakePaymentWithButton(!!result);
        }
      }
      this.setState({
        canMakePayment: !!result,
        applePay: result && result.applePay,
      });
    });

    this.state = {
      canMakePayment: false,
      applePay: false,
      paymentRequest,
    };
  }

  render() {
    if (this.props.children) {
      return this.props.children({
        canMakePayment: this.state.canMakePayment,
        showPaymentRequest: () => this.state.paymentRequest.show(),
      });
    }
    return null;
  }
}

const PaymentRequest = injectStripe(PaymentRequestForm);

export default PaymentRequest;
